/*
 * Script to avoid conflict for "_" global variable which is common on both 
 * Lodash and Underscore libraries
 */
( function($) {

    /**
     * Determines if _ is lodash or not
     */
    var isLodash = false;
    // If _ is defined and the function _.forEach exists then we know underscore OR lodash are in place
    if ( 'undefined' != typeof( _ ) && 'function' == typeof( _.forEach ) ) {

        // A small sample of some of the functions that exist in lodash but not underscore
        var LODASH_FUNCS = [ 'get', 'set', 'at', 'cloneDeep' ];

        // Simplest if assume exists to start
        isLodash  = true;

        LODASH_FUNCS.forEach( function ( func ) {
            // If just one of the functions do not exist, then not lodash
            isLodash = ( 'function' != typeof( _[ func ] ) ) ? false : isLodash;
        } );
    }

    /**
     * Address conflicts
     */
    if ( isLodash ) {
        // We know that lodash is loaded in the _ variable
        _.noConflict();
    }

})( jQuery );